import { render, staticRenderFns } from "./TopicHeader.vue?vue&type=template&id=149c709e&"
import script from "./TopicHeader.vue?vue&type=script&lang=js&"
export * from "./TopicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports